/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_You_Can_Customize_These_EmailsInputs */

const en_admin_resource_form_you_can_customize_these_emails = /** @type {(inputs: Admin_Resource_Form_You_Can_Customize_These_EmailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can customize these emails`)
};

const de_admin_resource_form_you_can_customize_these_emails = /** @type {(inputs: Admin_Resource_Form_You_Can_Customize_These_EmailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kannst diese E-Mails anpassen.`)
};

const es_admin_resource_form_you_can_customize_these_emails = /** @type {(inputs: Admin_Resource_Form_You_Can_Customize_These_EmailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes personalizar estos correos electrónicos`)
};

const fr_admin_resource_form_you_can_customize_these_emails = /** @type {(inputs: Admin_Resource_Form_You_Can_Customize_These_EmailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous pouvez personnaliser ces e-mails`)
};

const nl_admin_resource_form_you_can_customize_these_emails = /** @type {(inputs: Admin_Resource_Form_You_Can_Customize_These_EmailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je kunt deze e-mails aanpassen`)
};

/** @type {(inputs: Admin_Resource_Form_You_Can_Customize_These_EmailsInputs) => LocalizedString} */
const it_admin_resource_form_you_can_customize_these_emails = en_admin_resource_form_you_can_customize_these_emails;

/** @type {(inputs: Admin_Resource_Form_You_Can_Customize_These_EmailsInputs) => LocalizedString} */
const pt_br2_admin_resource_form_you_can_customize_these_emails = en_admin_resource_form_you_can_customize_these_emails;

/** @type {(inputs: Admin_Resource_Form_You_Can_Customize_These_EmailsInputs) => LocalizedString} */
const pl_admin_resource_form_you_can_customize_these_emails = en_admin_resource_form_you_can_customize_these_emails;

/** @type {(inputs: Admin_Resource_Form_You_Can_Customize_These_EmailsInputs) => LocalizedString} */
const hu_admin_resource_form_you_can_customize_these_emails = en_admin_resource_form_you_can_customize_these_emails;

/** @type {(inputs: Admin_Resource_Form_You_Can_Customize_These_EmailsInputs) => LocalizedString} */
const ro_admin_resource_form_you_can_customize_these_emails = en_admin_resource_form_you_can_customize_these_emails;

/**
* | output |
* | --- |
* | "You can customize these emails" |
*
* @param {Admin_Resource_Form_You_Can_Customize_These_EmailsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_you_can_customize_these_emails = /** @type {((inputs?: Admin_Resource_Form_You_Can_Customize_These_EmailsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_You_Can_Customize_These_EmailsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_you_can_customize_these_emails(inputs)
	if (locale === "de") return de_admin_resource_form_you_can_customize_these_emails(inputs)
	if (locale === "es") return es_admin_resource_form_you_can_customize_these_emails(inputs)
	if (locale === "fr") return fr_admin_resource_form_you_can_customize_these_emails(inputs)
	if (locale === "nl") return nl_admin_resource_form_you_can_customize_these_emails(inputs)
	if (locale === "it") return it_admin_resource_form_you_can_customize_these_emails(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_you_can_customize_these_emails(inputs)
	if (locale === "pl") return pl_admin_resource_form_you_can_customize_these_emails(inputs)
	if (locale === "hu") return hu_admin_resource_form_you_can_customize_these_emails(inputs)
	return ro_admin_resource_form_you_can_customize_these_emails(inputs)
});
export { admin_resource_form_you_can_customize_these_emails as "admin.resource_form.you_can_customize_these_emails" }